(() => {
  if (document.documentElement.dataset.maplFunnelReady) return;
  document.documentElement.dataset.maplFunnelReady = 'true';
  const send = (...args) => {
    if (typeof window.clarity === 'function') window.clarity(...args);
  };
  let attempts = 0;
  const tagSession = () => {
    if (typeof window.clarity !== 'function') {
      if (++attempts < 20) window.setTimeout(tagSession, 1000);
      return;
    }
    send('set', 'mapl_funnel_version', '2026-10-11-v1');
    send('set', 'mapl_environment', window.Shopify?.theme?.role === 'main' ? 'live' : 'preview');
    send('set', 'mapl_language', document.documentElement.lang || 'unknown');
  };
  tagSession();
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.open || !item.dataset.maplFaqKey) return;
    send('set', 'mapl_faq_opened', item.dataset.maplFaqKey);
    send('event', 'MaplFaqOpened');
  }, true);
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-mapl-mixed-offer] a')) send('event', 'MaplMixedOfferClicked');
    if (event.target.closest('.mapl-fast-checkout')) send('event', 'MaplExpressCheckoutClicked');
    if (event.target.closest('[data-mapl-shop] [name="add"], [data-mapl-shop] .mapl-shop__sticky-submit')) send('event', 'MaplAddToCartClicked');
  });
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (event.target.name === 'selling_plan') send('set', 'mapl_purchase_option', event.target.value ? 'subscription' : 'one_time');
  });
})();
